export default __webpack_public_path__ + "static/media/gallery-big-06.275001e3.jpg";